var moduleSelector = require('diy/site-admin/module-selector/moduleSelector');
var api = require('../api');

/**
 * Class for module selector
 *
 * @class ModuleSelector
 * @depends jquery.js, controller.js
 * @author Mihai Curelea
 */
/* globals diy */
(function() {

    this.controllerLoaded = false;
	/* specific actions for module selector */
    this.afterFillContent = function(el, data, contentElement) {
        moduleSelector.default.afterFillContent(el, data, contentElement);

        api.updateTitle(jimdoData.messages.moduleSelector.window.title);
        api.updateDescr(jimdoData.messages.moduleSelector.window.description);
        api.updateButtons({});
        api.updateNavi({});
        api.updateHelpTopic('moduleSelector');
        api.updateFeatureGuidanceHelp('elements');
        this.controllerLoaded = true;
    };

    this.allowSwitch = function()
    {
        return this.controllerLoaded;
    };


    this.show = function() {
        moduleSelector.default.show();
    };

    this.hide = function() {
        moduleSelector.default.clearSelection();
    };

    this.reset = function() {
        moduleSelector.default.reset();
    };

    return this;

}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/site-admin/main/controllers/moduleSelector.js
 ** module id = 795
 ** module chunks = 0
 **/